const SKIP_PATTERNS = [
  /^mailto:/i,
  /^tel:/i,
  /^https?:\/\/apps\.apple\.com/i,
  /^https?:\/\/play\.google\.com/i,
];

export function withUtm(
  url: string,
  opts: { medium: string; campaign: string }
): string {
  if (!url || SKIP_PATTERNS.some((p) => p.test(url))) return url;
  try {
    const u = new URL(url);
    if (!u.searchParams.has("utm_source"))
      u.searchParams.set("utm_source", "ldpteado");
    if (!u.searchParams.has("utm_medium"))
      u.searchParams.set("utm_medium", opts.medium);
    if (!u.searchParams.has("utm_campaign"))
      u.searchParams.set("utm_campaign", opts.campaign);
    return u.toString();
  } catch {
    return url;
  }
}
